// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
import fetchGraphqlClient from '@workspace/nextjs_utils/src/fetchGraphqlClient';
import useMutation, { type MutationOptions } from '../../useMutation';
import { Auth0MutationDocument, type Auth0Mutation, type Auth0MutationVariables } from './Auth0Mutation';

export async function getAuth0MutationClient(variables: Auth0MutationVariables) {
  return fetchGraphqlClient<Auth0Mutation, Auth0MutationVariables>(Auth0MutationDocument, "Auth0Mutation", { variables });
}
export const useAuth0Mutation = (options?: MutationOptions) => useMutation<Auth0Mutation, Auth0MutationVariables>(getAuth0MutationClient, options);